import React from 'react'
import FlatButton from 'material-ui/FlatButton'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import ReactTooltip from 'react-tooltip'

import { FormattedMessage } from 'react-intl'
import { checkJapanese } from '../../../lib'
import config from '../../../config/config'
import Clipboard from 'react-clipboard.js'

const Recording = ({
   recordings,
   selectConferenceId,
   isFetchingRecordList,
   pathname
 }) => {
  return (
    <div>
      <ReactTooltip place="left" multiline effect="solid" html/>
      <Table
        style={{borderBottom: '1px solid #d9d9d9'}}
        height="60vh"
        selectable={false}>
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
          style={{backgroundColor: '#ecedef'}}>
          <TableRow
            data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese()
              ? '録画映像はセミナーを\n終了すると作成されます。'
              : 'Recording files will be created when the seminar is ended.'}
              </div>`}>
            {false && <TableHeaderColumn
              style={{textAlign: 'center', fontSize: 14, color: '#6B7C93'}}>
              <FormattedMessage id="inviteModal.recording.date"/>
            </TableHeaderColumn>}
            <TableHeaderColumn
              style={{textAlign: 'center', fontSize: 14, color: '#6B7C93'}}>
              <FormattedMessage id="inviteModal.recording.name"/>
            </TableHeaderColumn>
            <TableHeaderColumn
              style={{textAlign: 'center', fontSize: 14, color: '#6B7C93'}}>
              <FormattedMessage id="inviteModal.recording.size"/>
            </TableHeaderColumn>
            <TableHeaderColumn
              style={{textAlign: 'center', fontSize: 14, color: '#6B7C93'}}>
              <FormattedMessage id="inviteModal.recording.duration"/>
            </TableHeaderColumn>
            <TableHeaderColumn/>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {isFetchingRecordList ? (
            <TableRow>
              <TableRowColumn style={{textAlign: 'center'}}>
                Fetching recordings...
              </TableRowColumn>
            </TableRow>
          ) : recordings.length >= 1 ? (
            recordings.map((val, index) => (
              <TableRow key={index}>

                <TableRowColumn
                  style={{
                    textAlign: 'center',
                    fontSize: 14,
                    color: '#6B7C93'
                  }}>
                  {`${val.index}: ${val.user_name}`}
                </TableRowColumn>
                <TableRowColumn
                  style={{
                    textAlign: 'center',
                    fontSize: 14,
                    color: '#6B7C93'
                  }}>
                  {val.size}
                </TableRowColumn>
                <TableRowColumn
                  style={{
                    textAlign: 'center',
                    fontSize: 14,
                    color: '#6B7C93'
                  }}>
                  {val.duration}
                </TableRowColumn>
                <TableRowColumn className="pr3" style={{padding: 0}}>
                  <FlatButton
                    onTouchTap={e => {window.open(`${config.URI}/api/v1/record_download?id=${selectConferenceId}&file_name=${val.file_name}&token=${val.jwt_token}`)}}
                    label={'play'}
                    labelStyle={{color: '#2D92EE'}}
                  />

                  <Clipboard
                    data-clipboard-text={`${config.URI}/api/v1/record_download?id=${selectConferenceId}&file_name=${val.file_name}&token=${val.jwt_token}`}>
                    <FlatButton
                      label={'共有リンク'}
                      labelStyle={{color: '#2D92EE'}}
                    />
                  </Clipboard>

                </TableRowColumn>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableRowColumn style={{textAlign: 'center'}}>
                <FormattedMessage id="inviteModal.recording.404"/>
              </TableRowColumn>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  )
}

export default Recording



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/Recording.js